import { useQuery } from 'react-query'
import { queryKeys } from 'constants/queryKeys'
import { getProducts } from 'api/GetRequests'
import { Item } from './types/ItemTypes'

const useProducts = () => useQuery<Item[]>([queryKeys.products], getProducts, {})

export default useProducts
